/*
 * @Descripttion: 
 * @version: 
 * @Author: chenlongad
 * @Date: 2020-11-09 10:05:07
 * @LastEditors: chenlongad
 * @LastEditTime: 2020-12-23 14:39:51
 */
import React, { Component } from 'react';
import { KeyboardInput } from 'tplus-components-touch'
import { platform } from 'mutants-util';
import tools from '../../../util/tools'

class NumberBoard extends React.Component {
  constructor(props, context) {
    super(props, context)
    const { isHorizontalPad, isHorizontalSunMi } = platform || {};
    this.isHorizontalPad = !!isHorizontalPad;
    this.isHorizontalSunMi = !!isHorizontalSunMi;
  }

  ok = () => {
    let ok = this.props.ok;
    var value = this.value;
    if (!value || !(value+"").trim().length) {
      this.handleInputFocus();
      return;
    } 
    ok();
  }

  handleInputFocus = () => {
    if (this.isHorizontalPad) return;
    setTimeout(() => {
      const modal = document.getElementsByClassName('modal-form-content')[0];
      if (!modal) return;
      const input = modal.getElementsByTagName('input')[0];
      if (this.isHorizontalSunMi) {
        if (input) setTimeout(() => { input.focus() }, 250)
      } else {
        if (input) input.focus();
      }
    }, 0)
  }

  componentDidMount() {
    this.handleInputFocus()
  }

  render() {
    let fileModel = this.props.data;
    let changeValue = this.props.changeValue;
    this.value = fileModel.Value;
    return (
      <KeyboardInput
        type={fileModel.abs ? "positive" : ''}
        {...fileModel}
        onChange={(val) => {
          if (isNaN(val)) return;
          val = tools.handleNumberInput(val)
          changeValue(fileModel, val);
          this.value = val;
        }}
        value={fileModel.Value}
        handleOk={()=>{this.ok()}}
      />
    )
  }
}
export default NumberBoard;